import { SelectEvent } from './select-event';

export class MenuEvent {
    commandId: string;
    currentTextSelected: SelectEvent;
}
